const PATH_REGEX = /^\/((?:(?:public\/)?posts)|embed)\/(?:.*-)?(\w+)\/?$/;

const parsePostPath = (pathname: string) => {
  const matched = pathname.match(PATH_REGEX);
  if (matched) {
    return { id: matched[2], path: matched[1] };
  }

  return null;
};

export default parsePostPath;
